import { render, staticRenderFns } from "./submitbutton.vue?vue&type=template&id=d105915a&scoped=true"
import script from "./submitbutton.vue?vue&type=script&lang=js"
export * from "./submitbutton.vue?vue&type=script&lang=js"
import style0 from "./submitbutton.vue?vue&type=style&index=0&id=d105915a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../Booker.Web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d105915a",
  null
  
)

export default component.exports